module.exports = __webpack_public_path__ + "static/20190527_182747_optimized-21336e7cdc4dae7885b793d37450299a.jpg";